jQuery(document).ready(function($){

    // $('html, body').animate({ scrollTop: 0 }, 0); // instant scroll
    

    var totalQuestion = 9;
    var currentQuestion = 0;
    var selections = {};

    var preferredProduct = 'onefit';
    var created = false;

    

    $(document).on('click','.test-result',function(){
        var certNumber = $(this).attr('data-cert-number');
        var lastTested = $(this).attr('data-last-tested');
        $('.cert-number span').html(certNumber);
        $('.last-tested span').html(lastTested);
    });



    $(document).on('click','#btn-back-quiz',function(){

        
        var activeStepContainer = $('.quiz-step-container.active');
        var prevStepContainer = activeStepContainer.prevAll('.quiz-step-container:not(.quiz-step-info-container)').first();
        
        // If Final Stage and went back
        var preferredProduct = localStorage.getItem('quiz_preferred_product');
        if ($('.quiz-last-step-container').hasClass('active') && preferredProduct == 'onelife'){
            var activeStepContainer = $('.quiz-step-container.active');
            var prevStepContainer = $('[data-back-from-final-for-onelife]');
        }


        // if onefit, and back, skip onelife, return to protein reference
        if ($('.quiz-last-step-container').hasClass('active') && preferredProduct == 'onefit'){
            var activeStepContainer = $('.quiz-step-container.active');
            var prevStepContainer = $('.quiz-step-protein-preference-container');
        }


        // OneFit Type
        if (activeStepContainer.hasClass('quiz-step-flavour-preference-container')){
            var quiz_selection_protein_preference = localStorage.getItem('quiz_selection_protein_preference');

            if (quiz_selection_protein_preference == 'plant-based'){
                prevStepContainer = $('.quiz-step-protein-preference-container');
            }

        }
      


        activeStepContainer.removeClass('active');
        prevStepContainer.addClass('active');

        checkCLoseButtonStatus();
        checkBar();
        


    });

    $(document).on('click','.quiz-step-container [data-action]',function(){
        var action = $(this).attr('data-action');

        var parentStepContainer = $(this).parents('.quiz-step-container');
        var nextStepContainer = parentStepContainer.next('.quiz-step-container');
        


        switch (action){
            case 'submit-result':

                
                const email = $(".quiz-email").val().trim();
                const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

                if ( email === "" || !emailPattern.test(email) ) {
                    alert("Please enter a valid email address.");
                }else{

                    // $('.quiz-submit-button').prop('disabled',true).html('Please wait...');
                    // $('#btn-back-quiz').css('display','none!importnt');
                    $(".quiz-email").prop('readonly',true);

                    // console.log('Quiz Submission Response',response);
                    // parentStepContainer.removeClass('active');
                    // nextStepContainer.addClass('active');
                    selections['email'] = email;

                    console.log('Quiz Submission Payload',selections);

                    $.post('https://app.usefon.com/wp-json/fon/v1/quiz-pre-register', selections)
                    .done(function(response){
                        created = true;

                        $(".quiz-email").prop('readonly', false);
                        $('.quiz-submit-button').prop('disabled', false).html('Submit');

                        // ✅ Success flow
                        parentStepContainer.removeClass('active');
                        nextStepContainer.addClass('active');
                        console.log("✅ Pre-registration saved!");
                        checkBar();
                    })
                    .fail(function(jqXHR){
                        let errorMessage = "❌ Something went wrong. Please try again.";

                        try {
                            let json = JSON.parse(jqXHR.responseText);
                            if (json.message) {
                                errorMessage = "⚠️ " + json.message;
                            }
                        } catch(e) {
                            console.error("Error parsing error response:", e);
                        }

                        $(".quiz-email").prop('readonly', false);
                        $('.quiz-submit-button').prop('disabled', false).html('Submit');

                        alert(errorMessage);
                    });

                }

                 return false;

            break;

            case 'submit-phone':

                const phone = $(".quiz-phone").val().trim();

                if ( phone === "" ) {
                    alert("Please enter your phone number.");
                } else {

                    $(".quiz-phone").prop('readonly', true);

                    selections['phone'] = phone;

                    console.log('📱 Quiz Submission Payload', selections);

                    $.post('https://app.usefon.com/wp-json/fon/v1/quiz-pre-register', selections)
                    .done(function(response){
                        created = true;

                        $(".quiz-phone").prop('readonly', false);
                        $('.quiz-submit-phone-button').prop('disabled', false).html('Submit');

                        // ✅ Success flow
                        parentStepContainer.removeClass('active');
                        nextStepContainer.addClass('active');
                        console.log("✅ Pre-registration saved!");
                        checkBar();

                        // Final Stage
                        if (nextStepContainer.hasClass('quiz-final-step-container')){
                            createSelections();
                        }
                    })
                    .fail(function(jqXHR){
                        let errorMessage = "❌ Something went wrong. Please try again.";

                        try {
                            let json = JSON.parse(jqXHR.responseText);
                            if (json.message) {
                                errorMessage = "⚠️ " + json.message;
                            }
                        } catch(e) {
                            console.error("Error parsing error response:", e);
                        }

                        $(".quiz-phone").prop('readonly', false);
                        $('.quiz-submit-phone-button').prop('disabled', false).html('Submit');

                        alert(errorMessage);
                    });

                }

                return false;

            break;

            case 'next-section-product':
                var preferredProduct = $(this).attr('data-product');

                localStorage.setItem('quiz_preferred_product',preferredProduct);
          
                parentStepContainer.removeClass('active');
                nextStepContainer.addClass('active');

                $('#"offer-onelife').hide();
                if (preferredProduct == 'onefit'){
                    $('#"offer-onelife').show();
                }
            break;

            // If not Onefit
            case 'next-section-check-next':

                var preferredProduct = localStorage.getItem('quiz_preferred_product');
                var skipTo = $(this).attr('data-skip-to');
                if (preferredProduct == 'onelife'){
                    parentStepContainer.removeClass('active');
                    $('.quiz-last-step-container').addClass('active');
                }else{
                    parentStepContainer.removeClass('active');
                    nextStepContainer.addClass('active');
                }
                
            break;

            case 'next-section-text-capture':

                var dataKey = $(this).attr('data-name');
                var dataField = $('.'+dataKey);
                var dataValue = dataField.val();

                dataField.removeClass('error');
                if (dataValue == ''){
                    dataField.addClass('error');
                }else{
                    const safeKey = dataKey.replace(/-/g, "_");
                    selections[safeKey] = dataValue;
                    updateSelections();

                    localStorage.setItem('quiz_' + safeKey,dataValue);
                    parentStepContainer.removeClass('active');
                    nextStepContainer.addClass('active');

                }

            break;

            case 'next-section':
                parentStepContainer.removeClass('active');
                nextStepContainer.addClass('active');
            break;

            case 'same-section':
                // parentStepContainer.removeClass('active');
                // nextStepContainer.addClass('active');
                parent = $(this).parents('.quiz-info-container');
                var condition = $(this).attr('data-condition');

                parent.hide();
                parent.siblings('[data-condition="'+condition+'"]').show();

            break;
            
            case 'next-section-skip-to':

                var preferredProduct = localStorage.getItem('quiz_preferred_product');
                var skipTo = $(this).attr('data-skip-to');

                if (skipTo == 'protein-preference'){
                    if (preferredProduct == 'onelife'){
                        parentStepContainer.removeClass('active');
                        $('.quiz-step-additional-onelife-container').addClass('active');
                    }else{
                        parentStepContainer.removeClass('active');
                        $('.quiz-step-container[data-skip-to="'+skipTo+'"]').addClass('active');
                    }
                }else{
                    parentStepContainer.removeClass('active');
                    $('.quiz-step-container[data-skip-to="'+skipTo+'"]').addClass('active');
                }
                
            break;

            case 'set-selection':

                var dataCondition = $(this).attr('data-condition');
                var dataKey = $(this).attr('data-key');
                var dataValue = $(this).attr('data-value');

                // var dataValue = $(this).html().trim();

                const safeKey = dataKey.replace(/-/g, "_");
                selections[safeKey] = dataValue;
                updateSelections();


                localStorage.setItem('quiz_' + safeKey,dataValue);

                // Custom Condition
                switch (safeKey){
                    case 'selection_age':
                        $('.quiz-quote .quote').addClass('d-none');
                        $('.quiz-quote .quote[data-condition="'+dataCondition+'"]').removeClass('d-none');
                    break;
                }


                

                // If condition is set
                if (dataCondition){


                    // Custom action
                    // alert(dataCondition);

                    switch (dataCondition){
               

                        case 'stopping-taste-texture':
                            if (localStorage.getItem('quiz_selection_gender')) {
                                var gender = localStorage.getItem('quiz_selection_gender'); // male / female

                                console.log('gender',gender);
                                
                                var $video = $('.video-player-taste');
                                var $source = $video.find('source');

                                var videoSource = $source.attr('data-' + gender);

                                $source.attr('src', videoSource);
                                $video[0].load();
                                // $video[0].play(); // uncomment if you want autoplay
                            }
                        break;
                        case 'stopping-works':
                            if (localStorage.getItem('quiz_preferred_product')) {
                                var preferredProduct = localStorage.getItem('quiz_preferred_product');
                                $('.quiz-works').addClass('d-none');

                                if (preferredProduct == 'onefit'){
                                    $('.quiz-works[data-product="onefit"]').removeClass('d-none');
                                }else if (preferredProduct == 'onelife'){
                                    $('.quiz-works[data-product="onelife"]').removeClass('d-none');
                                }else{
                                    $('.quiz-works[data-product="onelife"]').removeClass('d-none');
                                }
                            }
                        break;
                    }



                    if (nextStepContainer.hasClass('quiz-step-info-container') && nextStepContainer.find('.quiz-info-container[data-condition="'+dataCondition+'"]').length ){
                        nextStepContainer.find('.quiz-info-container').hide();
                        nextStepContainer.find('.quiz-info-container[data-condition="'+dataCondition+'"]').show();
                    }

                    parentStepContainer.removeClass('active');
                    nextStepContainer.addClass('active');


                    

                }else{
                    // Next question
                    parentStepContainer.removeClass('active');
                    nextStepContainer = parentStepContainer.nextAll('.quiz-step-container:not(.quiz-step-info-container)').first();
                    nextStepContainer.addClass('active');

                    // OneFit Type
                    if (nextStepContainer.hasClass('quiz-step-supplement-container')){
                        var quiz_selection_protein_preference = localStorage.getItem('quiz_selection_protein_preference');

                        $('.quiz-step-supplement-container .answer').show();
                        if (quiz_selection_protein_preference == 'plant-based'){
                            $('.quiz-step-supplement-container .answer[data-value="pouches"]').trigger('click');
                        }

                    }


                    // OneFit Type
                    if (nextStepContainer.hasClass('quiz-step-protein-preference-container')){
                        var quiz_selection_supplement_type = localStorage.getItem('quiz_selection_supplement_type');
                        $('.quiz-step-container.quiz-step-protein-preference-container .answer').show();
                        if (quiz_selection_supplement_type == 'sachets'){
                           $('.quiz-step-container.quiz-step-protein-preference-container .answer[data-value="plant-based"]').hide(); 
                        }
                        
                    }
                    // Flavour
                    if (nextStepContainer.hasClass('quiz-step-flavour-preference-container')){
                        var quiz_selection_protein_preference = localStorage.getItem('quiz_selection_protein_preference');
                        var quiz_selection_supplement_type = localStorage.getItem('quiz_selection_supplement_type');

                        var className = '.answer-' + quiz_selection_protein_preference + '-' +quiz_selection_supplement_type;
                   
                        $('.quiz-step-flavour-preference-container .quiz-answers .answer').hide();
                        $('.quiz-step-flavour-preference-container .quiz-answers ' + className).show();
                        
                        if ($('.quiz-step-flavour-preference-container .quiz-answers ' + className).length === 1){
                            $('.quiz-step-flavour-preference-container .quiz-answers ' + className).first().trigger('click');
                        }
                    }

                    // OneLife
                    if (nextStepContainer.hasClass('quiz-step-additional-onelife-container')){
                        var preferredProduct = localStorage.getItem('quiz_preferred_product');
                        if (preferredProduct == 'onefit'){
                            nextStepContainer.removeClass('active');
                            $('.quiz-last-step-container').addClass('active');
                             localStorage.setItem('quiz_additional_onelife','no');
                        }
                        
                    }

                    // Final Stage
                    if (nextStepContainer.hasClass('quiz-final-step-container')){
                        createSelections();
                    }
                }

                

            break;
        }

        
        checkCLoseButtonStatus();
        checkBar();

        pauseAllVideos();

    });

    $(document).on("change", "#offer-onelife", function() {
        if ($(this).is(":checked")) {
            selections['selection_additional_onelife'] = 'yes';
            localStorage.setItem('quiz_additional_onelife','yes');
        } else {
            selections['selection_additional_onelife'] = 'no';
            localStorage.setItem('quiz_additional_onelife','no');
        }
        
    });

    function createSelections(){
        if (created){
            $.post('https://app.usefon.com/wp-json/fon/v1/quiz',selections,function(response){
                console.log('response',response);

                setTimeout(() => {
                    window.location.href = '/pages/quiz-results';
                }, 4000);
            });
        }
    }
    function updateSelections(){
        if (created){
            $.post('https://app.usefon.com/wp-json/fon/v1/quiz-pre-register', selections, function(response){
            console.log('response', response);

            if (response.code) {
                alert("⚠️ " + response.message);
                return;
            }

            // success handling here if needed
            console.log("✅ Pre-registration saved!");
            }).fail(function(){
                alert("❌ Failed to save your pre-registration. Please try again.");
            });
        }
    }

    function checkCLoseButtonStatus(){
        if ($('.quiz-step-container.active').hasClass('quiz-step-intro-container')){
            $('#btn-back-quiz').addClass('d-none');
            $('.quiz-bar .bar').css('width','1%');
        }else{
            $('#btn-back-quiz').removeClass('d-none');
        }
        
    }
    function checkBar(){
       
        var activeStepContainer = $('.quiz-step-container.active');
        if (activeStepContainer.find('.quiz-question-answer').attr('data-question')){
            currentQuestion = parseInt(activeStepContainer.find('.quiz-question-answer').attr('data-question'));
            currentQuestion++;
            var percentage = 100 / 10;
            var currentBar = percentage * currentQuestion;
            $('.quiz-bar .bar').css('width',currentBar + '%');
        }

        
    }
    // function scrollToSection(section){

    //     alert('test');
    //     if (section.length) {
    

    //     // Smooth scroll to it
    //     $('html, body').animate({
    //         scrollTop: section.offset().top
    //     }, 600); // 600ms for smooth effect
    //     }
    // }
var quizSwiper = new Swiper('.swiper-quiz-testimonial', {
  loop: true,
  slidesPerView: 1,       // show 1 slide at a time
  autoplay: {
    delay: 3000,          // 3 seconds
    disableOnInteraction: false
  },
  allowTouchMove: true    // finger swipe enabled
});

// // Pause/resume on hover
// const swiperEl = document.querySelector('.swiper-quiz-testimonial');

// swiperEl.addEventListener('mouseenter', () => {
//   quizSwiper.autoplay.stop();
// });

// swiperEl.addEventListener('mouseleave', () => {
//   quizSwiper.autoplay.start();
// });


    const swiper = new Swiper('.swiper-videosx', {
    loop: true,
    slidesPerView: 1.49, // Default for mobile-first (smallest screens)
    spaceBetween: 20,
    speed: 300,
    autoplay: {
      delay: 4500, // Time between slides in milliseconds
      disableOnInteraction: false, // Keep autoplay after user interaction
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      1024: {
        slidesPerView: 1.3, // Larger screens (default)
      },
    },
  });

  const swiperContainer = document.querySelector('.swiper-videosx');

  if (swiperContainer) {
    swiperContainer.addEventListener('mouseenter', () => {
      swiper.autoplay.stop();
    });

    swiperContainer.addEventListener('mouseleave', () => {
      swiper.autoplay.start();
    });
  }
  
$(".video-wrapper").each(function(){
  var $wrapper = $(this);
  var $video = $wrapper.find(".video-player");
  var $playBtn = $wrapper.find(".video-play-button");



    // Ensure inline playback on iOS Safari
  $video.attr({
    playsinline: true,
    "webkit-playsinline": true
  });


  // ✅ Force load (important for mobile when hidden initially)
  $video.each(function() {
    this.load();
  });

  // Play/Pause when button is clicked
  $playBtn.on("click", function(){
    if ($video.get(0).paused) {
      $video.get(0).play();
      $wrapper.addClass("playing");
    } else {
      $video.get(0).pause();
      $wrapper.removeClass("playing");
    }
  });

  // Play/Pause when video itself is clicked
  $video.on("click", function(){
    if (this.paused) {
      this.play();
      $wrapper.addClass("playing");
    } else {
      this.pause();
      $wrapper.removeClass("playing");
    }
  });

  // Reset state when paused or ended
  $video.on("pause ended", function(){
    $wrapper.removeClass("playing");
  });
});

  $(".video-wrapper").on("show", function(){
  var $video = $(this).find(".video-player").get(0);
  if ($video) $video.load();
});

  function pauseAllVideos() {
    $(".video-player").each(function(){
        this.pause(); // pause the video
        $(this).closest(".video-wrapper").removeClass("playing");
    });
    }


    const phoneInput = document.querySelector("#phone");

    // Function to fetch user's country dial code using GetGeoAPI
    async function fetchCountryDialCode() {
        try {
        const response = await fetch(`https://api.getgeoapi.com/v2/ip/check?api_key=6be9e5e33b3f9ee33ee7ebd401a82a65472dc1f1&format=json`);
        const data = await response.json();
        const countryCode = data.country.code;
        const dialCode = data.country.phone_code;

        // Initialize intl-tel-input with the fetched dial code
        const iti = window.intlTelInput(phoneInput, {
            initialCountry: countryCode.toLowerCase(),
            utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/25.5.2/build/js/intlTelInputWithUtils.min.js"
        });

        // Set the input value to include the dial code
        phoneInput.value = iti.getNumber();

        } catch (error) {
        console.error("Error fetching country dial code:", error);
        }
    }

    // Call the function to fetch and set the dial code
    fetchCountryDialCode();


    $(document).on('click','.btn-test-results-return',function(){
        $.magnificPopup.close();
    });
});